export class VirtualPosInput {
    public name: string = '';
}
